const JSONP = {
    callbackPrefix: 'jsonp_callback_',
    randomMax: 100000,
    timeoutMs: 10000,
};

export default JSONP;